import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {WorkrequestBoeViewmodel} from '../workrequest-boe-viewmodel';
import {FormControl, Validators} from '@angular/forms';
import {WorkrequestBoeDetails} from '../workrequest-boe-details';
import {FeeService} from '../../../shared/services/fee.service';
import {SERVICE_PROVIDER} from '../../../shared/services/fee.service';
import {LoginService} from '../../../shared/services/login.service';
import {AddressService} from '../../../shared/services/address.service';

@Component({
  selector: 'app-workrequest-boe',
  templateUrl: './workrequest-boe.component.html',
  styleUrls: ['./workrequest-boe.component.css']
})
export class WorkrequestBoeComponent implements OnInit {

  @Input()
  set isReadOnly(v: boolean) {
    this.isReadOnlyImp = v;
    if (v) {
      this.otherControl.disable();
    } else {
      this.otherControl.enable();
    }
    if (v) {
      this.basementRequiredControl.disable();
    } else {
      this.basementRequiredControl.enable();
    }
    if (v) {
      this.cutFillRequiredControl.disable();
    } else {
      this.cutFillRequiredControl.enable();
    }
    if (v) {
      this.garageCarportShedRequiredControl.disable();
    } else {
      this.garageCarportShedRequiredControl.enable();
    }
    if (v) {
      this.verandahPergolaRequiredControl.disable();
    } else {
      this.verandahPergolaRequiredControl.enable();
    }
    if (v) {
      this.swimmingPoolSpaRequiredControl.disable();
    } else {
      this.swimmingPoolSpaRequiredControl.enable();
    }
    if (v) {
      this.buildingRequiredControl.disable();
    } else {
      this.buildingRequiredControl.enable();
    }
    if (v) {
      this.dwellingEavesRequiredControl.disable();
    } else {
      this.dwellingEavesRequiredControl.enable();
    }
  }

  get isReadOnly(): boolean {
    return this.isReadOnlyImp;
  }

  @Input()
  workRequestViewModel: WorkrequestBoeViewmodel;

  @Output()
  onFeeCodesReceived: EventEmitter<void>;

  basementRequiredControl: FormControl;
  dwellingEavesRequiredControl: FormControl;
  cutFillRequiredControl: FormControl;
  garageCarportShedRequiredControl: FormControl;
  verandahPergolaRequiredControl: FormControl;
  swimmingPoolSpaRequiredControl: FormControl;
  buildingRequiredControl: FormControl;
  otherControl: FormControl;

  otherControlLength = 100;
  pricingZone: string = SERVICE_PROVIDER.CWW;
  private isReadOnlyImp = false;

  constructor(private loginService: LoginService, private feeService: FeeService, private addressService: AddressService) {
    if (!this.workRequestViewModel) {
      this.workRequestViewModel = new WorkrequestBoeViewmodel();
    }
    if (!this.workRequestViewModel.workrequestDetails) {
      this.workRequestViewModel.workrequestDetails = new WorkrequestBoeDetails();
    }

    this.onFeeCodesReceived = new EventEmitter();
    this.otherControl = new FormControl('', [Validators.maxLength(this.otherControlLength)]);
    this.basementRequiredControl = new FormControl({value: false, disabled: false});
    this.cutFillRequiredControl = new FormControl({value: false, disabled: false});
    this.garageCarportShedRequiredControl = new FormControl({value: false, disabled: false});
    this.verandahPergolaRequiredControl = new FormControl({value: false, disabled: false});
    this.swimmingPoolSpaRequiredControl = new FormControl({value: false, disabled: false});
    this.dwellingEavesRequiredControl = new FormControl({value: false, disabled: false});
    this.buildingRequiredControl = new FormControl({value: false, disabled: false});

    // fetch pricing zone (CWW / WW)
    this.addressService.getPricingZone().subscribe(_pricingzone => {
      this.pricingZone = _pricingzone.toUpperCase() === SERVICE_PROVIDER.WW ? SERVICE_PROVIDER.WW : SERVICE_PROVIDER.CWW;
      console.log('PrizeZone:', this.pricingZone);
    }, err => {
      this.pricingZone = SERVICE_PROVIDER.CWW;
    });
  }

  ngOnInit() {
    this.loadFees();
  }

  loadFees(): void {
    this.feeService.retrieveFees('BuildOverEasements', this.loginService.getToken(), ok => {
        if (ok) {
          this.workRequestViewModel.feeAmount = this.feeService.getBOEFee(this.pricingZone);
          this.totalOrderAmount = this.workRequestViewModel.feeAmount;
          this.onFeeCodesReceived.emit();
        } else {
          console.log('no fees found');
        }
      },
      err => {
        // Log errors if any
        console.log(err);
      });
  }

  get isValid(): boolean {
    return this.workRequestViewModel.isValid;
  }

  get other(): string {
    return this.workRequestViewModel.otherText ?  this.workRequestViewModel.otherText.trim() : '';
  }

  set other(v: string) {
    if (v) {
      v = v.trim();
    }
    this.workRequestViewModel.otherText = v;
  }

  get basementRequired(): boolean {
    return this.workRequestViewModel.basementRequired;
  }

  set basementRequired(v: boolean) {
    this.workRequestViewModel.basementRequired = v;
  }

  get cutFillRequired(): boolean {
    return this.workRequestViewModel.cutFillRequired;
  }

  set cutFillRequired(v: boolean) {
    this.workRequestViewModel.cutFillRequired = v;
  }

  get verandahPergolaRequired(): boolean {
    return this.workRequestViewModel.verandahPergolaRequired;
  }

  set verandahPergolaRequired(v: boolean) {
    this.workRequestViewModel.verandahPergolaRequired = v;
  }

  get swimmingPoolSpaRequired(): boolean {
    return this.workRequestViewModel.swimmingPoolSpaRequired;
  }

  set swimmingPoolSpaRequired(v: boolean) {
    this.workRequestViewModel.swimmingPoolSpaRequired = v;
  }

  get dwellingEavesRequired(): boolean {
    return this.workRequestViewModel.dwellingEavesRequired;
  }

  set dwellingEavesRequired(v: boolean) {
    this.workRequestViewModel.dwellingEavesRequired = v;
  }

  get buildingRequired(): boolean {
    return this.workRequestViewModel.buildingRequired;
  }

  set buildingRequired(v: boolean) {
    this.workRequestViewModel.buildingRequired = v;
  }

  set garageCarportShedRequired(v: boolean) {
    this.workRequestViewModel.garageCarportShedRequired = v;
  }

  get garageCarportShedRequired(): boolean {
    return this.workRequestViewModel.garageCarportShedRequired;
  }


  get basementRequiredText(): string {
    return this.workRequestViewModel.basementRequiredText;
  }

  get cutFillRequiredText(): string {
    return this.workRequestViewModel.cutFillRequiredText;
  }

  get verandahPergolaRequiredText(): string {
    return this.workRequestViewModel.verandahPergolaRequiredText;
  }

  get swimmingPoolSpaRequiredText(): string {
    return this.workRequestViewModel.swimmingPoolSpaRequiredText;
  }

  get dwellingEavesRequiredText(): string {
    return this.workRequestViewModel.dwellingEavesRequiredText;
  }

  get buildingRequiredText(): string {
    return this.workRequestViewModel.buildingRequiredText;
  }

  get garageCarportShedRequiredText(): string {
    return this.workRequestViewModel.garageCarportShedRequiredText;
  }

  get totalOrderAmount(): number {
    return this.workRequestViewModel.workrequestDetails.totalOrderAmount;
  }

  set totalOrderAmount(v: number) {
    this.workRequestViewModel.workrequestDetails.totalOrderAmount = v;
  }

  markAsTouched() {
    this.basementRequiredControl.markAsTouched();
    this.cutFillRequiredControl.markAsTouched();
    this.garageCarportShedRequiredControl.markAsTouched();
    this.verandahPergolaRequiredControl.markAsTouched();
    this.swimmingPoolSpaRequiredControl.markAsTouched();
    this.dwellingEavesRequiredControl.markAsTouched();
    this.buildingRequiredControl.markAsTouched();
    this.otherControl.markAsTouched();
    this.loadFees();
  }
}




// WEBPACK FOOTER //
// ./src/app/create-application/boe-form/workrequest-boe/workrequest-boe.component.ts